
import { API_ENDPOINTS } from './api-endpoints';
import { crudFactory } from './curd-factory';
import { HttpClientFront } from './http-client-front';


export const getIndicesDetails = {
  
  ...crudFactory(API_ENDPOINTS.INDICES),
  get:({ 
    id,
    ...params 
  }) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.INDICES}/`+id, {
      ...params,
      
    });
  },
  all:(params ) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.INDICES}`, params);
  },
};